<div class="filter-div">
  <label
    class="filter-text"
    [ngClass]="
      isGroupCriteria ? 'filter-text-margins' : 'indented-filter-text-margins'
    "
  >
    Filter
  </label>
  <ng-select
    id="column.id"
    [items]="filterItems"
    bindLabel="text"
    [clearable]="false"
    [searchable]="false"
    (change)="filter($event)"
    [(ngModel)]="activeItem"
    placeholder="- Select Filter -"
    class="filter-select"
    *ngIf="filterItems && filterItems.length > 1"
  >
  </ng-select>
</div>
<div
  class="filter-div text-input-div"
  *ngIf="filterItems && filterItems.length > 1 && activeItem"
>
  <ng-container *ngIf="metricLabelsForDropdown">
    <ng-select
      [items]="metricLabelsForDropdown"
      bindValue="numericValue"
      bindLabel="alphaValue"
      (change)="emitOnMinChangeEvent()"
      [(ngModel)]="min"
      placeholder="No min selected"
      [clearable]="false"
      class="filter-select min-value-select"
      [ngClass]="{ 'min-value-criteria-select': isGroupCriteria }"
      *ngIf="selectedFilterItem && selectedFilterItem.id == '2'"
    ></ng-select>
    <p
      *ngIf="selectedFilterItem && selectedFilterItem.id == '2'"
      class="and-text"
    >
      and
    </p>
    <ng-select
      [items]="metricLabelsForDropdown"
      bindValue="numericValue"
      bindLabel="alphaValue"
      (change)="emitOnMaxChangeEvent()"
      [(ngModel)]="max"
      placeholder="No max selected"
      [clearable]="false"
      class="filter-select max-value-select"
      [ngClass]="{ 'max-value-criteria-select': isGroupCriteria }"
      *ngIf="selectedFilterItem && selectedFilterItem.id == '2'"
    ></ng-select>
    <ng-select
      [items]="metricLabelsForDropdown"
      bindValue="numericValue"
      bindLabel="alphaValue"
      (change)="
        singleValChange.emit(singleVal); filterChange.emit(selectedFilterItem)
      "
      [(ngModel)]="singleVal"
      placeholder="No value selected"
      [clearable]="false"
      class="filter-select"
      [ngClass]="
        isGroupCriteria ? 'single-value-criteria-select' : 'single-value-select'
      "
      *ngIf="
        selectedFilterItem &&
        (selectedFilterItem.id == '3' ||
          selectedFilterItem.id == '4' ||
          selectedFilterItem.id == '5')
      "
    ></ng-select>
  </ng-container>
  <ng-container *ngIf="!metricLabelsForDropdown">
    <input
      type="number"
      class="form-control filter-input"
      [ngClass]="isGroupCriteria ? 'min-group-criteria-input' : 'min-input'"
      id="min"
      [ngModel]="min"
      (ngModelChange)="onMinChange($event)"
      name="min"
      placeholder="0"
      *ngIf="selectedFilterItem && selectedFilterItem.id == '2'"
    />
    <p
      *ngIf="selectedFilterItem && selectedFilterItem.id == '2'"
      class="and-text"
    >
      and
    </p>
    <input
      type="number"
      class="form-control filter-input"
      [ngClass]="isGroupCriteria ? 'max-group-criteria-input' : 'max-input'"
      id="max"
      [ngModel]="max"
      (ngModelChange)="onMaxChange($event)"
      name="max"
      placeholder="80"
      *ngIf="selectedFilterItem && selectedFilterItem.id == '2'"
    />
    <input
      type="number"
      class="form-control filter-input"
      [ngClass]="
        isGroupCriteria ? 'single-val-group-criteria-input' : 'single-val-input'
      "
      id="singleVal"
      [ngModel]="singleVal"
      (ngModelChange)="onSingleValChange($event)"
      name="singleVal"
      placeholder="50"
      *ngIf="
        selectedFilterItem &&
        (selectedFilterItem.id == '3' ||
          selectedFilterItem.id == '4' ||
          selectedFilterItem.id == '5')
      "
    />
  </ng-container>
</div>
